<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { tick } from 'svelte';
    import { onMount } from 'svelte';
    import { clientSettings, api } from '../../../stores/api';
    import ButtonZoneLock from '../Filter/ButtonZoneLock.svelte';
    import Switch from '../../shared/Switch.svelte';
    import ButtonRoundCancel from '../../shared/ButtonRoundCancel.svelte';
    import SelectDay from '../../shared/SelectDay.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import IconBalance from '../../shared/Icons/IconBalance.svelte';
    import IconSnapToGrid from '../Zones/IconSnapToGrid.svelte';
    import { ZoneEditor } from '../Zones/ZoneEditor';
    import IconPlayCircle from '../../shared/Icons/IconPlayCircle.svelte';
    import IconStopCircle from '../../shared/Icons/IconStopCircle.svelte';
    import IconTetris from '../../shared/Icons/IconTetris.svelte';
    import { DaysWithJobsToProcessApp } from '../AppMainStatus/DaysWithJobsToProcessApp';

    export let showGridModeSwitch: boolean = false;
    export let gridMode: boolean = false;
    //export let onGridModeSwitch: (state: boolean) => void = (state) => {};
    export let volume: {dateRange: number[], type: string, average: boolean, strictDates: boolean};
    export let zoneEditor: ZoneEditor | null = null;
    export let onOptionChange: (option: string, value: unknown) => void = (option, value) => {};
    export let onSave: () => void;
    export let onDiscard: () => void;
    export let onRender: () => void = () => {};

    let container: HTMLDivElement;
    let volumeControls: any;
    let tmpVolume: {dateRange: number[], type: string, average: boolean, strictDates: boolean} = {...volume};
    let daysApp: DaysWithJobsToProcessApp = new DaysWithJobsToProcessApp($api, ['all', 'all+']);
    let zones: any[] = zoneEditor ? zoneEditor.getZones() : [];

    let tools: Record<string, any> = {
        balanceZones: {
            active: false,
            disabled: zones.length < 2,
            onClick: () => {
                if (zoneEditor) {
                    if (!tools.balanceZones.active) {
                        if (tools.tetris.active) {
                            tools.tetris.active = false;
                            zoneEditor.gridTetrisModeStop().then(() => {
                                tools.balanceZones.onClick();
                            });
                            return;
                        }
                        zoneEditor.gridMarkMostUnbalancedZones((action: string) => {
                            if (action == 'onMark') {
                                if (!tools.balanceZones.active) {
                                    tools.balanceZones.active = true;
                                }
                            }
                            if (action == 'onUnmark') {
                                tools.balanceZones.active = false;
                            }
                        });
                    }
                }
            },
            stop: () => {
                if (zoneEditor && tools.balanceZones.active) {
                    setTimeout(() => {
                        tools.balanceZones.active = false;
                        zoneEditor.gridUnmarkMostUnbalancedZones();
                    }, 0);
                }
            },
            next: () => {
                if (zoneEditor) {
                    zoneEditor.gridBalanceMostUnbalancedZones();
                }
            }
        },
        snapToGrid: {
            active: false,
            disabled: zones.length < 1,
            onClick: () => {
                if (zoneEditor) {
                    tools.balanceZones.stop();
                    zoneEditor.gridSnapZones();
                }
            }
        },
        tetris: {
            active: false,
            disabled: false,
            onClick: () => {
                if (zoneEditor) {
                    tools.tetris.active = !tools.tetris.active;
                    if (tools.tetris.active) {
                        tools.balanceZones.stop();
                        zoneEditor.gridTetrisModeStart();
                    } else {
                        zoneEditor.gridTetrisModeStop();
                    }
                }
            }
        }
    };

    moment.locale('pl');
    let defaultJobDateRanges: Record<string, string[]> = {
        '+/- dwa dni': [moment().subtract(2, 'days').format(), moment().add(2, 'days').format()],
        'Ostatni tydzień': [moment().subtract(6, 'days').format(), moment().format()]
    };

    function onZonesChange() {
        zones = zoneEditor ? zoneEditor.getZones() : [];
        tools.balanceZones.disabled = zones.length < 2;
        tools.snapToGrid.disabled = zones.length < 1;
    }

    function onVolumeChange(value) {
        volume = {
            type: tmpVolume.type,
            average: tmpVolume.average,
            strictDates: tmpVolume.strictDates,
            dateRange: value.map((d) => Math.round(moment(d).diff(moment().set({hour: 0, minute: 0, second: 0, millisecond: 0}), 'days', true)))
        }
        console.log('SelectDay, onChange', volume);
        onOptionChange('volume', volume);
    }

    async function waitForDOM() {
        await tick();
        let dateDropdownIcon = container.querySelector('.select-day-container .icon');
        dateDropdownIcon.style.width = '20px';
        dateDropdownIcon.style.height = '20px';
        onRender();
        //console.log('TacticalPlanRuleMapControl, container size', container.clientWidth, container.clientHeight);
    }

    onMount(() => {
        zoneEditor?.addEventListener('zoneRemove', onZonesChange);
        zoneEditor?.addEventListener('zoneAdd', onZonesChange);
        zoneEditor?.addEventListener('zonesChange', onZonesChange);
        waitForDOM();
    });


</script>

<div class="container" bind:this={container}>
    {#if showGridModeSwitch}
        <div class="section">
            <div>
                {$_('zone_editor_mode')}:
            </div>
            <div>
                <Switch checked={gridMode} label={$_('zone_editor_grid_mode')} offLabel={$_('zone_editor_polygon_mode')} colorOff={true} on:change={ev => {
                    gridMode = !gridMode;
                    //onGridModeSwitch(gridMode);
                    onOptionChange('gridMode', gridMode);
                }}/>
            </div>
        </div>
    {/if}
    <div class="section">
        <SelectDay
            day={volume.dateRange.map((d) => moment().add(d, 'days').format())}
            autoApply={false}
            showRelativeToday={$clientSettings.display.showRelativeToday}
            drops="up"
            opens="center"
            presets={defaultJobDateRanges}
            {daysApp}
            modal={true}
            classForDay={(q) => { return q['all+'] > 0 ? (q['all'] > 0 ? {'blue': $_('zone_editor_jobs_for_day')} : {'blue pale': $_('zone_editor_jobs_for_day_or_outdated')}) : null; }}
            onChange={onVolumeChange}
            on:calendarShow={(ev) => {
                tmpVolume = {...volume};
                let picker = ev.detail.picker;
                const rect = picker.element.get(0).getBoundingClientRect();
                picker.container.css({
                    top: rect.top - picker.container.outerHeight() + window.scrollY,
                    left: rect.left + (picker.element.outerWidth() - picker.container.outerWidth()) / 2 + window.scrollX,
                    right: 'auto',
                    position: 'absolute'
                });
                if (!picker.container.get(0).querySelector('.volume-controls')) {
                    picker.container.get(0).insertBefore(volumeControls, picker.container.get(0).firstChild);
                    volumeControls.style.display = 'flex';
                }
            }}
        />
        <div class="volume-controls" style="display: none; padding: 10px; border-bottom: 1px solid #ddd; justify-content: center; align-items: center; gap: 15px;" bind:this={volumeControls}>
            <select id="volume-control-type" style="color: #1b5abf; background-color: white; border: 1px solid #ccc; border-radius: 3px; padding: 7px;" on:change={(ev) => {
                tmpVolume.type = ev.target.value;
            }}>
                <option value="parcels" selected={(tmpVolume.type == 'parcels')}>{$_('parcels')}</option>
                <option value="jobs" selected={(tmpVolume.type == 'jobs' )}>{$_('jobs')}</option>
                <option value="stops" selected={(tmpVolume.type == 'stops' )}>{$_('Quantity of stops')}</option>
            </select>
            <Checkbox bind:checked={tmpVolume.average} label={$_('zone_editor_average_per_day')}/>
            <Checkbox bind:checked={tmpVolume.strictDates} label={$_('zone_editor_reject_outdated')}/>
        </div>
    </div>
    {#if gridMode}
        <div class="section">
            <div class="tool" class:tool-active={tools.balanceZones.active} class:tool-disabled={tools.balanceZones.disabled} style="display: flex; align-items: center" on:click={tools.balanceZones.onClick}>
                <IconBalance scale={0.65} title={$_('zone_editor_balance_zones')}/>
                {#if tools.balanceZones.active}
                    <IconPlayCircle scale={0.7} on:click={tools.balanceZones.next}/>
                    <IconStopCircle scale={0.7} on:click={tools.balanceZones.stop}/>
                {/if}
            </div>
            <div class="tool" on:click={tools.snapToGrid.onClick} class:tool-disabled={tools.snapToGrid.disabled} style="display: flex; align-items: center">
                <IconSnapToGrid scale={0.65} title={$_('zone_editor_snap_zones_to_grid')}/>
            </div>
            <div class="tool" class:tool-active={tools.tetris.active} class:tool-disabled={tools.tetris.disabled} on:click={tools.tetris.onClick}>
                <IconTetris scale={0.65} title={$_('zone_editor_tetris_mode')}/>
            </div>
        </div>
    {/if}
    <div>
        <ButtonRoundCancel
            opacity={0.5}
            on:click={onDiscard}
        />
    </div>
    <div>
        <ButtonZoneLock
            on:click={onSave}
        />
    </div>
</div>

<style>
    .container {
        display: flex;
        gap: 10px;
        align-items: center;
        height: 33px;
        background-color: #ffffffcc;
        border-radius: 15px;
        padding: 5px;
        box-sizing: border-box;
    }
    .section {
        display: flex;
        align-items: center;
        padding: 3px 6px;
        gap: 5px;
        border: 1px solid #777;
        border-radius: 14px;
    }
    .section :global(.select-day-container .icon) {
        width: 20px;
        height: 20px;
    }
    .tool {
        padding: 1px 3px;
        border-radius: 3px;
    }
    .tool-active {
        background-color: var(--automapa-blue-medium)
    }
    .tool-active :global(img) {
        filter: invert(1);
    }
    .tool-disabled {
        opacity: 0.5;
        pointer-events: none;
    }
</style>